export default {
  BOOKING_RESOURCES_FILTER: store => {
    return store.bookingResourcesFilter;
  }
};
